import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "@/components/ui/dialog";
import { useRef } from "react";
import type { SectionNavigationDialogProps } from "./SectionNavigationDialog.types";
import SectionNavigationSidebar from "./SectionNavigationSidebar";
import { useScrollSync } from "./useScrollSync";

const SectionNavigationDialog = ({
  isOpen,
  onClose,
  title = "Documentation",
  sections,
  children,
}: SectionNavigationDialogProps) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const { activeSection, scrollToSection } = useScrollSync(
    contentRef,
    sections,
    isOpen,
  );

  return (
    <DialogOverlay isOpen={isOpen}>
      <DialogContent
        onClose={onClose}
        size="lg"
        className="h-[calc(100vh-2rem)]"
      >
        {title && (
          <DialogHeader>
            <DialogTitle className="font-serif text-lg">{title}</DialogTitle>
          </DialogHeader>
        )}

        <DialogBody className="p-0">
          <div className="flex h-full">
            {/* Nav Sidebar - Left Side */}
            <SectionNavigationSidebar
              sections={sections}
              activeSection={activeSection}
              onNavigate={scrollToSection}
            />

            {/* Content - Right Side */}
            <div className="flex-1 overflow-hidden rounded-br-lg">
              <div ref={contentRef} className="h-full overflow-y-auto p-6">
                {children}
              </div>
            </div>
          </div>
        </DialogBody>
      </DialogContent>
    </DialogOverlay>
  );
};

export default SectionNavigationDialog;
